import React from 'react';
import classes from './terms.module.css'


function Terms() {

  return (
    <div  className={classes.container}>
    <>
  <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
  <meta name="Generator" content="Microsoft Word 15 (filtered)" />
  <style
    dangerouslySetInnerHTML={{
      __html:
        '\n<!--\n /* Font Definitions */\n @font-face\n\t{font-family:Helvetica;\n\tpanose-1:2 11 6 4 2 2 2 2 2 4;}\n@font-face\n\t{font-family:Wingdings;\n\tpanose-1:5 0 0 0 0 0 0 0 0 0;}\n@font-face\n\t{font-family:"Cambria Math";\n\tpanose-1:2 4 5 3 5 4 6 3 2 4;}\n@font-face\n\t{font-family:Calibri;\n\tpanose-1:2 15 5 2 2 2 4 3 2 4;}\n@font-face\n\t{font-family:"DengXian Light";\n\tpanose-1:2 1 6 0 3 1 1 1 1 1;}\n@font-face\n\t{font-family:"\\@DengXian Light";}\n@font-face\n\t{font-family:"Roboto Light";}\n /* Style Definitions */\n p.MsoNormal, li.MsoNormal, div.MsoNormal\n\t{margin-top:0in;\n\tmargin-right:0in;\n\tmargin-bottom:6.0pt;\n\tmargin-left:0in;\n\tline-height:120%;\n\tfont-size:10.5pt;\n\tfont-family:"Calibri",sans-serif;\n\tcolor:#595959;}\nh1\n\t{mso-style-link:"Heading 1 Char";\n\tmargin-top:12.0pt;\n\tmargin-right:0in;\n\tmargin-bottom:3.0pt;\n\tmargin-left:.25in;\n\ttext-indent:-.25in;\n\tline-height:120%;\n\tfont-size:12.0pt;\n\tfont-family:"Calibri",sans-serif;\n\tcolor:#5B9BD5;}\nh2\n\t{mso-style-link:"Heading 2 Char";\n\tmargin-top:3.0pt;\n\tmargin-right:0in;\n\tmargin-bottom:3.0pt;\n\tmargin-left:19.0pt;\n\ttext-indent:-19.0pt;\n\tline-height:120%;\n\tfont-size:10.5pt;\n\tfont-family:"Calibri",sans-serif;\n\tcolor:#595959;\n\tfont-weight:normal;\n\ttext-decoration:underline;}\nh2.CxSpFirst\n\t{mso-style-link:"Heading 2 Char";\n\tmargin-top:3.0pt;\n\tmargin-right:0in;\n\tmargin-bottom:0in;\n\tmargin-left:19.0pt;\n\ttext-indent:-19.0pt;\n\tline-height:120%;\n\tfont-size:10.5pt;\n\tfont-family:"Calibri",sans-serif;\n\tcolor:#595959;\n\tfont-weight:normal;\n\ttext-decoration:underline;}\nh2.CxSpMiddle\n\t{mso-style-link:"Heading 2 Char";\n\tmargin-top:0in;\n\tmargin-right:0in;\n\tmargin-bottom:0in;\n\tmargin-left:19.0pt;\n\ttext-indent:-19.0pt;\n\tline-height:120%;\n\tfont-size:10.5pt;\n\tfont-family:"Calibri",sans-serif;\n\tcolor:#595959;\n\tfont-weight:normal;\n\ttext-decoration:underline;}\nh2.CxSpLast\n\t{mso-style-link:"Heading 2 Char";\n\tmargin-top:0in;\n\tmargin-right:0in;\n\tmargin-bottom:3.0pt;\n\tmargin-left:19.0pt;\n\ttext-indent:-19.0pt;\n\tline-height:120%;\n\tfont-size:10.5pt;\n\tfont-family:"Calibri",sans-serif;\n\tcolor:#595959;\n\tfont-weight:normal;\n\ttext-decoration:underline;}\np.MsoTitle, li.MsoTitle, div.MsoTitle\n\t{mso-style-link:"Title Char";\n\tmargin:0in;\n\ttext-align:center;\n\tfont-size:28.0pt;\n\tfont-family:"Calibri Light",sans-serif;\n\tletter-spacing:-.5pt;}\np.MsoTitleCxSpFirst, li.MsoTitleCxSpFirst, div.MsoTitleCxSpFirst\n\t{mso-style-link:"Title Char";\n\tmargin:0in;\n\ttext-align:center;\n\tfont-size:28.0pt;\n\tfont-family:"Calibri Light",sans-serif;\n\tletter-spacing:-.5pt;}\np.MsoTitleCxSpMiddle, li.MsoTitleCxSpMiddle, div.MsoTitleCxSpMiddle\n\t{mso-style-link:"Title Char";\n\tmargin:0in;\n\ttext-align:center;\n\tfont-size:28.0pt;\n\tfont-family:"Calibri Light",sans-serif;\n\tletter-spacing:-.5pt;}\np.MsoTitleCxSpLast, li.MsoTitleCxSpLast, div.MsoTitleCxSpLast\n\t{mso-style-link:"Title Char";\n\tmargin:0in;\n\ttext-align:center;\n\tfont-size:28.0pt;\n\tfont-family:"Calibri Light",sans-serif;\n\tletter-spacing:-.5pt;}\na:link, span.MsoHyperlink\n\t{color:#0563C1;\n\ttext-decoration:underline;}\np.p1, li.p1, div.p1\n\t{mso-style-name:p1;\n\tmargin-top:0in;\n\tmargin-right:0in;\n\tmargin-bottom:6.0pt;\n\tmargin-left:0in;\n\tline-height:120%;\n\tfont-size:28.0pt;\n\tfont-family:Helvetica;\n\tcolor:#232323;}\nspan.s1\n\t{mso-style-name:s1;}\nspan.Heading1Char\n\t{mso-style-name:"Heading 1 Char";\n\tmso-style-link:"Heading 1";\n\tfont-family:"Times New Roman",serif;\n\tcolor:#5B9BD5;\n\tfont-weight:bold;}\nspan.TitleChar\n\t{mso-style-name:"Title Char";\n\tmso-style-link:Title;\n\tfont-family:"Calibri Light",sans-serif;\n\tletter-spacing:-.5pt;}\nspan.msoIns\n\t{mso-style-name:"";\n\ttext-decoration:underline;\n\tcolor:teal;}\nspan.msoDel\n\t{mso-style-name:"";\n\ttext-decoration:line-through;\n\tcolor:red;}\n.MsoChpDefault\n\t{font-size:12.0pt;\n\tfont-family:"Calibri",sans-serif;}\n@page WordSection1\n\t{size:8.5in 11.0in;\n\tmargin:1.0in 1.0in 1.0in 1.0in;}\ndiv.WordSection1\n\t{page:WordSection1;}\n /* List Definitions */\n ol\n\t{margin-bottom:0in;}\nul\n\t{margin-bottom:0in;}\n-->\n'
    }}
  />
  <div className="WordSection1">
    <p className="p1">
      <span
        style={{
          fontSize: "11.0pt !msorm",
          lineHeight: "120% !msorm",
          color: "windowtext !msorm"
        }}
      >
        <span className="s1">
          <span style={{ fontFamily: '"Calibri",sans-serif' }}>&nbsp;</span>
        </span>
      </span>
    </p>
    <p className="MsoTitle">
      <span style={{ fontFamily: '"Calibri Light",sans-serif !msorm' }}>
        <span style={{ fontFamily: '"Calibri",sans-serif' }}>
          Terms and Conditions
        </span>
      </span>
    </p>
    <p className="MsoNormal">
      <br />
      <b>
        IMPORTANT:&nbsp;AS WITH ALL CONTRACTS, IF YOU ARE UNDER THE AGE OF 18,
        YOU MUST HAVE YOUR PARENT OR GUARDIAN READ THE AGREEMENT BELOW AND AGREE
        TO IT FOR YOU. IF YOU{" "}
      </b>
      <b>
        DON'T HAVE YOUR PARENT OR GUARDIAN READ AND AGREE TO THIS, YOU DON'T
        HAVE PERMISSION TO USE THIS SITE OR SERVICE. ALWAYS GET AN ADULT'S
        PERMISSION BEFORE GOING ONLINE.
      </b>
    </p>
    <p className="MsoNormal">&nbsp;</p>
    <h1>
      1.
      <span style={{ font: '7.0pt "Times New Roman"' }}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      Agreement between you and ClassGenius
    </h1>
    <p className="MsoNormal">
      1.1&nbsp;Please read the following terms of service&nbsp;<i>(t</i>
      <i>he “Terms”)</i>&nbsp;carefully. By creating an account, you acknowledge
      that you have read, understood and agree to be bound by these Terms, and
      the terms and conditions of the Privacy Policy&nbsp;
      <i>(as defined below)</i>, when using any service or services&nbsp;
      <i>(collectively, the</i>
      <i> “Service”)</i>&nbsp;offered by ClassGenius, Inc. or its parents,
      affiliates or subsidiaries&nbsp;<i>(collectively, “</i>
      <i>ClassGenius</i>
      <i>” or “we”)</i>, on or through the any site made available by
      ClassGenius, including the site located at
      https://www.classgenius.ai&nbsp;<i>(collectively, the “Site”)</i>. The
      term “you”&nbsp;<i>(and “your”)</i>&nbsp;for purposes of these Terms,
      means both you in your individual capacity, and if applicable, the company
      or other legal entity whom you represent and on whose behalf you use the
      Service.
    </p>
    <p className="MsoNormal">
      1.2&nbsp;In order to use the Service you must agree to these Terms.
      However, in addition to clicking the “I Accept” box, you may also agree to
      the Terms by actually using the Service. You acknowledge and agree that
      ClassGenius will treat your use of the Service as acceptance of these
      Terms from the time you first use the Service.
    </p>
    <p className="MsoNormal">
      ClassGenius reserves the right to change any of the terms and conditions
      contained in these Terms, including the Service and/or any policies or
      guidelines governing the Service, at any time and in its sole discretion.
      While we will endeavor to provide direct notice to you of any changes, you
      are responsible for periodically checking the Site to determine if any
      changes have been made and we are not liable for your failure to do so or
      our failure to provide such direct notice to you. Your continued use of
      the Service following any revision to these Terms will constitute your
      acceptance of the changes or modifications to these Terms. If you do not
      agree to any changes to these Terms, do not continue to use the Service.
    </p>
    <h1>
      2.
      <span style={{ font: '7.0pt "Times New Roman"' }}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      ClassGenius Account Creation and Types; User Limitations
    </h1>
    <p className="MsoNormal">
      2.1&nbsp;In order to use the Service, you must register with us to open a
      ClassGenius user account&nbsp;<i>(“Account”)</i>. By opening an Account,
      you represent and warrant that: (a) all information you submit in
      connection with your opening and use of your Account is true, accurate,
      current, and complete; (b) you will promptly notify us if your information
      changes so that we can update our records; (c) you are of legal age to
      form a binding contract&nbsp;<i>(</i>
      <i>
        or, if you are a minor, you have your parent's permission to use the
        Service, and your parent has read and agrees to these terms on your
        behalf)
      </i>
      ; and (d) your use of the Service does not violate any applicable law,
      rule or regulation, including the GDPR and COPPA (as defined below). You
      are responsible for maintaining this information current.
    </p>
    <p className="MsoNormal">
      2.2&nbsp;You are solely responsible for maintaining the security and
      confidentiality of the information you hold for your Account, including,
      without limitation, your user name and password, and for any and all
      activity that occurs through your Account as a result of your failure to
      keep this information secure and confidential. You hereby agree to notify
      ClassGenius immediately if you become aware of any unauthorized use of
      your Account, user name or password, or any other breach of security in
      connection therewith. You may be held liable for losses incurred by
      ClassGenius or any third party due to someone else using your Account,
      user name or password as a result of your failing to keep your Account
      information secure and confidential. You are strictly prohibited from
      using anyone else's Account, user name or password at any time and for any
      reason. ClassGenius is not liable to you or any third party for your
      failure to comply with your obligations under this paragraph.
    </p>
    <p className="MsoNormal">
      2.3&nbsp;The Service is made available by ClassGenius to the following
      user categories&nbsp;<i>(collectively, “Users”)</i>: (i) individual
      schools, school districts, and/or other educational institutions or
      companies&nbsp;<i>(each, a</i>
      <i> “School”)</i>&nbsp;for use by School teachers and related staff
      members&nbsp;<i>(each, a “Teacher”)</i>&nbsp;in connection with
      students&nbsp;<i>(each, a “Student”)</i>&nbsp;enrolled at such School; and
      (ii) individual parents and/or legal guardians&nbsp;
      <i>(each, a “Parent or Guardian”)</i>&nbsp;for use by Students under such
      Parent or Guardian’s care. In connection with your Account, you hereby
      agree to comply with all of the terms and conditions described herein that
      are applicable to each such User type.
    </p>
    <p className="MsoNormal">
      2.3.1&nbsp;If you are accessing the Service on behalf of a School, the
      following terms also apply to you:
    </p>
    <ul style={{ marginTop: "0in" }} type="disc">
      <li className="MsoNormal">
        You represent and warrant that you are solely responsible for complying
        with all applicable law, including, without limitation,
        the&nbsp;EU's&nbsp;
        <a href="https://gdpr-info.eu/" target="_blank">
          General Data Protection Regulation
        </a>
        &nbsp;(GDPR) and the&nbsp;
        <a
          href="https://membean.com/policies/www.ftc.gov/news-events/media-resources/protecting-consumer-privacy/kids-privacy-coppa"
          target="_blank"
        >
          Child Online Privacy Protection Act
        </a>
        &nbsp;(COPPA&nbsp;), which requires parental or legal guardian consent
        for online collection of personal information from children under 13.
        You must obtain advance written consent&nbsp;<i>(“Consent”)</i>
        &nbsp;from all parents or legal guardians whose children will be
        accessing the Service. When obtaining Consent, you must provide parents
        and legal guardian with a copy of our Privacy Policy&nbsp;
        <i>(as defined in Section 3 below)</i>. You must keep signed Consents on
        file and provide them to ClassGenius upon our request.
      </li>
      <li className="MsoNormal">
        You will only grant access credentials to Teachers who are current
        employees of your School. Upon termination of a Teacher’s employment
        with you, you will require such individual to return and cease using all
        such credentials he or she has in his or her possession. If at any time
        you learn a User of the Service claims to be affiliated with your School
        who is not, in fact, affiliated with your School, you will immediately
        notify ClassGenius.
      </li>
    </ul>
    <p className="MsoNormal">
      2.3.2&nbsp;If you are accessing the Service as a Teacher, the following
      terms also apply to you:
    </p>
    <ul style={{ marginTop: "0in" }} type="disc">
      <li className="MsoNormal">
        You represent and warrant that you have permission from your School to
        enter into these Terms and to use the Service as part of your
        curriculum. You further represent and warrant that you are entering into
        these Terms on behalf of your School, and that you have authority to
        bind your School to these Terms.
      </li>
      <li className="MsoNormal">
        You represent and warrant that you are solely responsible for complying
        with all applicable law, including, without limitation,
        the&nbsp;EU's&nbsp;
        <a href="https://gdpr-info.eu/" target="_blank">
          General Data Protection Regulation
        </a>
        &nbsp;(GDPR) and&nbsp;
        <a
          href="https://membean.com/policies/www.ftc.gov/news-events/media-resources/protecting-consumer-privacy/kids-privacy-coppa"
          target="_blank"
        >
          Child Online Privacy Protection Act
        </a>
        &nbsp;(COPPA&nbsp;), which requires parental consent for online
        collection of personal information from children under 13. You must
        obtain Consent from all parents whose children will be accessing the
        Service. When obtaining Consent, you must provide parents with a copy of
        our Privacy Policy. You must keep signed Consents on file and provide
        them to Company upon our request.
      </li>
    </ul>
    <p className="MsoNormal">
      2.3.3&nbsp;If you are accessing the Service as a Parent or Guardian, the
      following terms also apply to you:
    </p>
    <ul style={{ marginTop: "0in" }} type="disc">
      <li className="MsoNormal">
        You agree not to access the Account or information about anyone other
        than your Student.
      </li>
      <li className="MsoNormal">
        You understand that your acceptance of these Terms indicates that you
        are agreeing to these Terms both on your own behalf as well as on behalf
        of your Student(s) who use the Service. Children under 18 must not use
        the Service, however, until after a Parent or Guardian has accepted
        these Terms on their behalf.
      </li>
    </ul>
    <p className="MsoNormal">
      2.3.4&nbsp;If you are accessing the Service as a Student, the following
      terms also apply to you:
    </p>
    <ul style={{ marginTop: "0in" }} type="disc">
      <li className="MsoNormal">
        Remember, you must get your Parent or Guardian to read these Terms
        before using the Service.
      </li>
      <li className="MsoNormal">
        You will only register for and access the Service as a Student
        registrant, and not as a Teacher, School, Parent or Guardian, publisher,
        or any other category of User, whether offered by ClassGenius now or in
        the future.
      </li>
    </ul>
    <h1>
      3.
      <span style={{ font: '7.0pt "Times New Roman"' }}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      Your Privacy; Use of Service by Children
    </h1>
    <p className="MsoNormal">
      3.1&nbsp;In order to use the Service you, or your School or Parent or
      Guardian on your behalf, will be required to provide certain personally
      identifiable information to ClassGenius&nbsp;
      <i>
        (e.g., your first and last name, the name of the School on whose behalf
        you use the Service, your Student identification number,{" "}
      </i>
      <i>
        your e-mail address, and, if applicable, your credit card information)
      </i>
      . ClassGenius will only use such personally identifiable information in
      accordance with the terms of our&nbsp;privacy policy&nbsp;
      <i>(the “Privacy Policy”)</i>. In this regard, you agree to the
      then-current version of the Privacy Policy. You hereby agree that we may
      use your personally identifiable information in accordance with the terms
      of the Privacy Policy.
    </p>
    <p className="MsoNormal">
      3.2&nbsp;ClassGenius collects limited personal information from minor
      Students, but only where that Student’s School or Parent or Guardian has
      contracted with ClassGenius to collect personal information from Students
      for the use and benefit of the learning environment. ClassGenius requires
      Schools and/or Teachers to obtain Consent from Students’ Parents or
      Guardians before collecting any such personal information. If you are a
      Student, please do not send any personal information about yourself to us,
      other than what we request from you when you are able to sign up for the
      Service. In the event that we learn that we have collected personal
      information from a Student without a Consent being obtained by his or her
      School and/or Teacher, or if we learn a Student has provided us personal
      information beyond what we request when he or she signs up for the
      Service, we will permanently delete that information as quickly as
      possible. If you believe that a Student may have provided us personal
      information beyond what is requested when signing up for the Service, or
      that a Student's School or Teacher has not obtained a valid Consent prior
      to our collection of any personal information, please contact us at&nbsp;
      <a href="../7b81c2a2-a447-488d-a793-21c8f2d23d4b-12204d51-0ea4-46a3-8c92-73023b468cc3/help@classgenius.ai">
        help@classgenius.ai
      </a>
      .
    </p>
    <h1>
      4.
      <span style={{ font: '7.0pt "Times New Roman"' }}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      Fees
    </h1>
    <p className="MsoNormal">
      4.1&nbsp;The fees, if any, that Schools and/or Parents or Guardians are
      required to pay to permit use of the Service are set forth in the
      applicable quote provided by ClassGenius to you. Fees will be (a) billed
      periodically in accordance with such quote and (b) are payable as follows:
      (i) For Parents or Guardians, the credit card you maintain on file with
      ClassGenius in your Account will be automatically charged on the first day
      of each month for the following month; and (ii) for Schools, you agree to
      pay applicable periodic fees for the Service within thirty (30) days of
      the date of each applicable invoice. You are responsible for maintaining
      up to date credit card information, if applicable, in your Account.
      ClassGenius reserves the right to suspend or terminate your use of the
      Service (and access to your Content) if you fail to pay any fees due in
      connection with your use of the Service. Any outstanding fees are
      immediately due and payable upon termination of your use of the Service
      for any reason.
    </p>
    <p className="MsoNormal">
      4.2&nbsp;To the greatest extent permitted by applicable law, and without
      affecting your credit card issuer’s rights, you hereby waive all claims
      relating to fees unless you notify ClassGenius of any dispute or other
      fee-related claim within thirty (30) calendar days of the fees being
      charged to your credit card, if applicable.
    </p>
    <p className="MsoNormal">
      4.3&nbsp;To the greatest extent permitted by applicable law, any refunds
      of fees are at the sole discretion of ClassGenius, and refunds will only
      be provided in the form of a credit against future fees for the Service.
      Nothing in these Terms obligates ClassGenius to extend credit to any
      person. You acknowledge and agree that any credit card and related billing
      and payment information that you provide to ClassGenius may be shared by
      ClassGenius with third party service providers who work on ClassGenius’
      behalf, such as payment processors and/or credit agencies, solely for the
      purposes of checking credit, effecting payment to ClassGenius and
      servicing your Account. ClassGenius may also provide information in
      response to valid legal processes, such as subpoenas, search warrants and
      court orders, or to establish or exercise its legal rights or defend
      against legal claims. ClassGenius shall not be liable for any use or
      disclosure of such information by such third parties.
    </p>
    <h1>
      5.
      <span style={{ font: '7.0pt "Times New Roman"' }}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      Service Availability &amp; Support
    </h1>
    <p className="MsoNormal">
      5.1&nbsp;ClassGenius may temporarily suspend your and/or your Students’
      access to any portion or all of the Service and related Content&nbsp;
      <i>(as defined below)</i>&nbsp;if ClassGenius reasonably determines that:
      (a) there is a threat or attack on the Service (including a denial of
      service attack) or other event that may create a risk to the Service, you
      or any other Service user; (b) your or your Students’ use of the Service
      or your Content disrupts or poses a security risk to the Service or any
      other Service user, may harm ClassGenius’ systems or any other Service
      user, or may subject ClassGenius or any third party to liability; (c) you
      or your Students are using the Service for fraudulent or illegal
      activities; (d) subject to applicable law, you have ceased to continue
      your business in the ordinary course, made an assignment for the benefit
      of creditors or similar disposition of your assets, or become the subject
      of any bankruptcy, reorganization, liquidation, dissolution or similar
      proceeding; (e) you or your Students are using the Site, Service or other
      ClassGenius property in breach of these Terms; (f) you are in default of
      your payment obligations hereunder; or (g) there is an unusual spike or
      increase in your use of the Service (collectively, "Service Suspensions").
      ClassGenius will make commercially reasonable efforts, circumstances
      permitting, to provide written notice of any Service Suspension to
      you&nbsp;
      <i>
        (including notices posted on the Site or sent to your registered e-mail
        address)
      </i>
      &nbsp;and to provide updates regarding resumption of the Service following
      any Service Suspension. ClassGenius will have no liability for any damage,
      liabilities, losses&nbsp;<i>(including any loss of data or profits)</i>
      &nbsp;or any other consequences that you or your Students may incur as a
      result of any Service Suspension.
    </p>
    <p className="MsoNormal">
      5.2&nbsp;ClassGenius will provide customer support to you as is generally
      made available without charge to other users of the Service.
    </p>
    <h1>
      6.
      <span style={{ font: '7.0pt "Times New Roman"' }}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      Security
    </h1>
    <p className="MsoNormal">
      6.1&nbsp;You and your Students are solely responsible for properly
      configuring and using the Service and taking your own steps to maintain
      appropriate security, protection and backup of your Content, including
      using encryption technology to protect your Content from unauthorized
      access and routinely archiving your Content. ClassGenius is not
      responsible for any unauthorized access to, alteration of, or the
      deletion, destruction, damage, loss or failure to store any of, your or
      your Students’ Content or other data that you or your Students submit or
      use in connection with your Account or the Service.
    </p>
    <h1>
      7.
      <span style={{ font: '7.0pt "Times New Roman"' }}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      ClassGenius’s Proprietary Rights
    </h1>
    <p className="MsoNormal">
      7.1&nbsp;You hereby acknowledge and agree that ClassGenius&nbsp;
      <i>(or its licensors)</i>&nbsp;own all legal right, title and interest in
      and to the Site and Service, including, without limitation, any
      intellectual property or other proprietary rights which subsist in the
      Site and Service&nbsp;
      <i>
        (whether such rights are registered or unregistered, and wherever in the
        world those rights may exist)
      </i>
      . As between you and ClassGenius, all materials on the Site, including,
      but not limited to, content, graphics, user and visual interfaces, images,
      software, applications, and text, as well as the design, structure,
      selection, coordination, expression, "look and feel", and arrangement of
      the Site and its content&nbsp;<i>(except for your Content)</i>, and the
      domain names, trademarks, service marks, proprietary logos and other
      distinctive brand features found on the Site, are all owned by ClassGenius
      or licensors.
    </p>
    <p className="MsoNormal">
      7.2&nbsp;Nothing in these Terms gives you any right to use any of
      ClassGenius’ trade names, trademarks, service marks, logos, domain names,
      and other distinctive brand features. All rights not expressly granted by
      ClassGenius under these Terms are reserved.
    </p>
    <p className="MsoNormal">
      7.3&nbsp;Subject to your compliance with these Terms, including, without
      limitation, your payment of all applicable fees, ClassGenius hereby grants
      you and your Students a limited, personal, worldwide, royalty-free,
      non-transferable, non-sublicensable and non-exclusive license to use the
      Service for your educational purposes, to store and manage Content in such
      manner as permitted and/or specified by ClassGenius from time-to-time in
      any applicable documentation or Service descriptions made available by
      ClassGenius. This license is for the sole purpose of enabling you and your
      Students to use and enjoy the benefit of the Service as provided by
      ClassGenius, in the manner permitted by these Terms.
    </p>
    <p className="MsoNormal">
      7.4&nbsp;During, and after the termination of, your use of the Service,
      you will not assert, nor will you authorize or assist any third party to
      assert, against ClassGenius or any of the ClassGenius Parties (as defined
      below), any patent infringement claim with respect to the Service.
    </p>
    <h1>
      8.
      <span style={{ font: '7.0pt "Times New Roman"' }}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      Service Use Restrictions
    </h1>
    <p className="MsoNormal">
      8.1&nbsp;You hereby represent and warrant that you will not, and will not
      permit any third party, including without limitation Teachers and/or
      Students, to: (a) attempt to disable or circumvent any security mechanisms
      used by the Site or Service or otherwise attempt to gain unauthorized
      access to any portion or feature of the Site or Service, or any other
      systems or networks connected to the Site or Service, or to any
      ClassGenius server, by hacking, password "mining", or any other illegal
      means; (b) use any "deep-link", "page-scrape", "robot", "spider" or other
      automatic device, program, algorithm or methodology, or any comparable
      manual process, to access, acquire, copy, or monitor any portion of the
      Site or Service; (c) use any device, software or routine to interrupt or
      interfere, or attempt to interrupt or interfere with, the proper operation
      and working of the Site or Service or any transaction being conducted on
      the Site or through the Service, or with any other person's use of the
      Site or Service; (d) breach any security measures implemented on the Site
      or in the Service; (e) track or seek to trace any information on any other
      person who visits the Site or uses the Service; (f) forge headers or
      otherwise manipulate identifiers in order to disguise your identity, or
      the origin of any message or other communication that you send to
      ClassGenius in connection with the Service; (g) pretend that you are, or
      that you represent, someone else, or impersonate any other person; (h) use
      the Service in the design, development, production, or use of missiles or
      the design, development, production, stockpiling, or use of chemical or
      biological weapons; (i) use the Service or Site for any illegal purpose,
      for soliciting the performance of any illegal activity, or as otherwise
      prohibited by these Terms or applicable laws, rules or regulations,
      including, without limitation, laws applicable to the export of software
      and data; (j) upload or otherwise process any malicious content to, or
      through, the Service; or (k) copy, modify, create a derivative work of,
      reverse engineer, decompile or otherwise attempt to extract the source
      code of the any ClassGenius proprietary software used to provide,
      maintain, or otherwise applicable to, the Service, or made available to
      you in connection with the Service.
    </p>
    <p className="MsoNormal">
      8.2&nbsp;You hereby agree that you will notify ClassGenius if you become
      aware that the Site or Service is being used for any illegal or
      unauthorized purpose.
    </p>
    <h1>
      9.
      <span style={{ font: '7.0pt "Times New Roman"' }}>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      Your Content &amp; License from You
    </h1>
    <p className="MsoNormal">
      9.1&nbsp;You hereby agree that you are solely responsible and liable for
      any and all information, data files, written text, computer software,
      music, audio files or other sounds, photographs, videos, images, and other
      content&nbsp;<i>(collectively “Content”)</i>&nbsp;that you or your
      Students store, transmit, display, or otherwise use in connection with the
      Service, and for the consequences of your and your Students’ actions in
      connection with such Content and use of the Service. You agree that
      ClassGenius has no responsibility to you or to any third party in
      connection with such Content. You are solely responsible for any losses or
      damage suffered by ClassGenius in connection with your or your Students’
      Content. You hereby represent and warrant that neither you nor your
      Students will store or otherwise use any Content in connection with the
      Service that: (a) violates these Terms; (b) is defamatory, libelous,
      abusive, illegal, profane, indecent, pornographic, obscene, hateful,
      offensive, harassing, or threatening in any way; (c) constitutes or
      encourages conduct that would be considered a criminal offense or give
      rise to civil liability, or otherwise intentionally or unintentionally
      violate any law, rule or regulation; (d) violates any third party’s
      copyright, trademark, patent, trade secret, or other personal or
      proprietary right; (e) invades or interferes with the rights of privacy or
      publicity of any person; or (f) contains a virus, malicious code or any
      other harmful component.
    </p>
    <p className="MsoNormal">
      9.2&nbsp;ClassGenius reserves the right, at any time in its sole
      discretion and without notice to you, to pre-screen, review, monitor,
      flag, filter, modify, refuse or remove any or all Content from the
      Service, but ClassGenius has no obligation to do so. You agree to
      immediately take down, delete or modify any Content that is stored by you
      or your Students through the Service that violates these Terms or any
      applicable laws, rules, or regulations, including pursuant to a take down,
      deletion or modification request from ClassGenius. In the event that you
      or your Students elect not to comply with a request from ClassGenius to
      take down, delete or modify certain Content, ClassGenius reserves the
      right to directly take down, delete or modify such Content. ClassGenius
      assumes no liability or responsibility arising from your activities in
      connection with the Service, including, without limitation, Content that
      you store or otherwise use in connection with Service.
    </p>
    <p className="MsoNormal">
      9.3&nbsp;ClassGenius claims no ownership or control over your right, title
      and interest in your Content. You retain copyright and any other
      intellectual property and other proprietary rights you already hold in
      your Content, and you are solely responsible for protecting those rights,
      as you deem appropriate. By submitting, storing, displaying, or otherwise
      using your Content in connection with the Service, you hereby grant
      ClassGenius a worldwide, royalty-free, fully-paid-up, non-exclusive
      license to reproduce, perform, modifying display, distribute, and
      otherwise use such Content for the purpose of enabling ClassGenius to
      provide the Service to you and other Users, including, without limitation,
      storing and retrieving the Content, making the Content available through
      the Service, adapting the Content for technical display and transmission,
      conforming the Content to the limitation and terms of the Service, and any
      other use related to the maintenance, provision and improvement of the
      Service.
    </p>
    <p className="MsoNormal">
      9.4&nbsp;You hereby agree that ClassGenius, in its sole discretion, may
      use School trade names, trademarks, service marks, logos, domain names,
      and other distinctive brand features, in presentations, marketing
      materials, customer lists, financial reports and web site listings&nbsp;
      <i>(including links to your web site)</i>&nbsp;for the purpose of
      advertising or publicizing the Service.
    </p>
    <p className="MsoNormal">
      9.5&nbsp;ClassGenius will not disclose any of your Content, except: (a) if
      you expressly authorize us to do so in connection with your use of the
      Service; (b) as necessary to provide the Service to you and your Students;
      or (c) to comply with the request of any governmental or regulatory body,
      subpoenas or court orders, or as otherwise required by applicable law,
      rule or regulation. If we receive a subpoena, court order, or other
      request from a governmental or regulatory body requesting the disclosure
      of any of your Content, we will use good faith efforts to provide you with
      reasonable notice to allow you to seek a protective order or other
      appropriate remedy&nbsp;<i>(except to the extent </i>
      <i>ClassGenius</i>
      <i>’ compliance with the foregoing would cause it </i>
      <i>to violate a court order or other legal requirement)</i>. You are
      required to respond to third party requests about your Content, and we may
      provide your contact information to third parties, and suspend or
      terminate your access to the Service and your Content, if you fail to
      respond to such third party requests.
    </p>
    <p className="MsoNormal">
      9.6&nbsp;ClassGenius may use usage patterns, trends and other statistical
      data derived from your Content and use of the Service for purposes of
      providing, operating, maintaining, or improving the Service.
    </p>
    <h1>
      10.<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp; </span>
      Accuracy
    </h1>
    <p className="MsoNormal">
      10.1&nbsp;Materials and content on the site have been dynamically generated
      by artificial intelligence and machine learning. Use of the Service may 
      result in incorrect output being generated and returned by the Service. You
      should evaluate the accuracy of any output generated and returned by the 
      Service, including by using human review of such output.
    </p>
    <h1>
      11.<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp; </span>
      Feedback
    </h1>
    <p className="MsoNormal">
      11.1&nbsp;If you send or transmit any communications or materials to
      ClassGenius via the Site, the Services , by mail, electronic mail,
      telephone, in-person communication or otherwise&nbsp;<i>(“Feedback”)</i>,
      making or suggesting modifications to content provided by the Service, or suggesting or recommending changes to our Site or Service, including
      without limitation, new features or functionality relating thereto, any
      comments, questions, suggestions, or the like, all such Feedback are, and
      will be treated as, non-confidential and non-proprietary. This means that
      you give up any claim that the use of such Feedback by ClassGenius or its
      agents, violates any of your rights including moral rights, privacy
      rights, proprietary or other property rights, rights of publicity, rights
      to credit for material or ideas, or any other right, including the right
      to approve the way ClassGenius uses such Feedback.
    </p>
    <p className="MsoNormal">
      11.2&nbsp;You hereby assign all right, title, and interest in, and
      ClassGenius is free to use, without any attribution or compensation to
      you, any ideas, know-how, concepts, techniques, or other intellectual
      property rights contained in the Feedback, whether or not patentable, for
      any purpose whatsoever, including but not limited to, developing,
      manufacturing, having manufactured, licensing, marketing, and selling,
      directly or indirectly, products and services using such Feedback. You
      agree and understand that ClassGenius is not obligated to use, display,
      reproduce, or distribute any such ideas, know-how, concepts, or techniques
      contained in the Feedback, and you have no right to compel such use,
      display, reproduction, or distribution.
    </p>
    <h1>
      12.<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp; </span>
      Copyright Infringement
    </h1>
    <p className="MsoNormal">
      12.1&nbsp;ClassGenius respects the intellectual property and other
      proprietary rights of others and has a policy of removing content from the
      Site that infringes third party copyrights and suspending and/or
      terminating the Account of any user who uses the Site or Service in
      violation of copyright law, and where appropriate, blocking such user’s
      access to the Site and Service.
    </p>
    <p className="MsoNormal">
      12.2&nbsp;If you are a copyright owner, or an agent thereof, and believe
      that your work is the subject of copyright infringement and appears on our
      Site, or is being used through the Service, you may submit a notification
      pursuant to the Digital Millennium Copyright Act (DMCA) by providing our
      copyright agent&nbsp;<i>(designated below)</i>&nbsp;with the following
      information in writing: (a) your physical or electronic signature; (b)
      identification of the copyrighted work claimed to have been infringed; (c)
      identification of the material that is claimed to be infringing or to be
      the subject of infringing activity and that is to be removed or access to
      which is to be disabled, and information reasonably sufficient to permit
      ClassGenius to locate such material; (d) information reasonably sufficient
      to permit ClassGenius to contact you, such as an address, telephone
      number, and, if available, an e-mail address; (e) a statement that you
      have a good faith belief that use of the material in the manner complained
      of is not authorized by the copyright owner, its agent, or the law; and
      (f) a statement that the information in the notification is accurate, and
      under penalty of perjury, that you are, or that you are authorized to act
      on behalf of, the owner of an exclusive right that is allegedly infringed.
      ClassGenius’ designated copyright agent to receive notifications of
      claimed infringement under the&nbsp;DMCA&nbsp;is:{" "}
      <a href="../7b81c2a2-a447-488d-a793-21c8f2d23d4b-12204d51-0ea4-46a3-8c92-73023b468cc3/legal@classgenius.ai">
        legal@classgenius.ai
      </a>
      .
    </p>
    <p className="MsoNormal">
      12.3&nbsp;Only&nbsp;DMCA&nbsp;or other intellectual property
      rights-related notices should be sent to the copyright agent; any other
      communications sent to the copyright agent will be destroyed.
    </p>
    <h1>
      13.<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp; </span>
      Exclusion of Warranties
    </h1>
    <p className="MsoNormal">
      13.1&nbsp;YOUR USE OF THE SITE AND SERVICE IS ENTIRELY AT YOUR OWN
      DISCRETION AND RISK. THE SITE AND SERVICE ARE FURNISHED TO YOU “AS IS” AND
      WITHOUT WARRANTIES OR CONDITIONS, STATUTORY OR OTHERWISE, OF ANY KIND.
      CLASSGENIUS, ON BEHALF OF ITSELF, AND ON BEHALF OF ITS PARENTS,
      AFFILIATES, SUBSIDIARIES, LICENSORS AND THIRD PARTY SERVICE PROVIDERS, AND
      CLASSGENIUS’ AND THEIR DIRECTORS, OFFICERS, EMPLOYEES, CONTRACTORS,
      AGENTS, SUCCESSORS, AND ASSIGNS, (COLLECTIVELY, THE “CLASSGENIUS
      PARTIES”): (A) EXPRESSLY DISCLAIMS ALL WARRANTIES AND CONDITIONS, WHETHER
      EXPRESS, IMPLIED OR STATUTORY, INCLUDING, WITHOUT LIMITATION, THE IMPLIED
      WARRANTIES OF NON-INFRINGEMENT, TITLE, MERCHANTABILITY, AND FITNESS FOR A
      PARTICULAR PURPOSE; (B) DOES NOT WARRANT THAT THE SERVICE, OR DATA
      PROVIDED THROUGH THE SERVICE, WILL MEET YOUR REQUIREMENTS, OR THAT ITS
      OPERATION WILL BE TIMELY, UNINTERRUPTED, SECURE, OR ERROR-FREE OR THAT ANY
      DEFECTS WILL BE CORRECTED; AND (C) DOES NOT WARRANT OR MAKE ANY
      REPRESENTATIONS OR CONDITIONS REGARDING THE USE OR THE RESULTS OF THE USE
      OF THE SERVICE IN TERMS OF ITS ACCURACY, RELIABILITY, TIMELINESS,
      COMPLETENESS, OR OTHERWISE. YOU ASSUME TOTAL RESPONSIBILITY FOR YOUR USE
      OF THE SERVICE.
    </p>
    <p className="MsoNormal">
      13.2&nbsp;THIS LIMITATION OF REMEDIES IS A PART OF THE BARGAIN BETWEEN YOU
      AND CLASSGENIUS. NO ORAL OR WRITTEN INFORMATION OR ADVICE GIVEN BY
      CLASSGENIUS or ANY PERSON ON BEHALF OF CLASSGENIUS SHALL CREATE A WARRANTY
      OR CONDITION, OR IN ANY WAY CHANGE THIS EXCLUSION OF WARRANTY.
    </p>
    <p className="MsoNormal">
      13.3&nbsp;NOTHING IN THESE TERMS, THIS SECTION 12, OR SECTION 13 BELOW,
      SHALL EXCLUDE OR LIMIT CLASSGENIUS’ WARRANTY OR LIABILITY FOR LOSSES WHICH
      MAY NOT BE LAWFULLY EXCLUDED OR LIMITED BY APPLICABLE LAW.
    </p>
    <h1>
      14.<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp; </span>
      Exclusion of Liability
    </h1>
    <p className="MsoNormal">
      14.1&nbsp;SUBJECT TO SECTION 12.3 ABOVE, IN NO EVENT WILL CLASSGENIUS OR
      THE CLASSGENIUS PARTIES BE LIABLE TO YOU, OR ANY THIRD PARTY, FOR ANY
      SPECIAL, INDIRECT, INCIDENTAL, PUNITIVE, EXEMPLARY, RELIANCE, OR
      CONSEQUENTIAL DAMAGES OF ANY KIND, INCLUDING, BUT NOT LIMITED TO,
      COMPENSATION, REIMBURSEMENT OR DAMAGES IN CONNECTION WITH, ARISING OUT OF,
      OR RELATING TO, THE USE, OR LOSS OF USE OF, THE SERVICE, LOSS OF PROFITS,
      LOSS OF GOODWILL, LOSS OF DATA OR CONTENT, COST OF PROCUREMENT OF
      SUBSTITUTE GOODS OR SERVICES, SUBSEQUENT OR OTHER COMMERCIAL LOSS, OR FOR
      ANY OTHER REASON OF ANY KIND, WHETHER BASED ON CONTRACT OR TORT
      (INCLUDING, WITHOUT LIMITATION, NEGLIGENCE OR STRICT LIABILITY), EVEN IF
      CLASSGENIUS OR THE CLASSGENIUS PARTIES HAVE BEEN ADVISED OF THE
      POSSIBILITY OF SUCH DAMAGES.
    </p>
    <p className="MsoNormal">
      14.2&nbsp;CLASSGENIUS AND THE CLASSGENIUS PARTIES WILL NOT BE LIABLE TO
      YOU OR ANY THIRD PARTY FOR DAMAGES FOR BREACH OF ANY EXPRESS OR IMPLIED
      WARRANTY OR CONDITION, BREACH OF CONTRACT, NEGLIGENCE, STRICT LIABILITY OR
      ANY OTHER LEGAL THEORY RELATED TO THE SITE OR SERVICE. IF, NOTWITHSTANDING
      THE FOREGOING, CLASSGENIUS OR ONE OF THE CLASSGENIUS PARTIES IS FOUND TO
      BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DAMAGE OR LOSS WHICH ARISES
      UNDER OR IN CONNECTION WITH THESE TERMS OR THE SERVICE, CLASSGENIUS OR THE
      RELEVANT CLASSGENIUS PARTY'S TOTAL CUMULATIVE LIABILITY TO YOU OR ANY
      THIRD PARTY SHALL IN NO EVENT EXCEED THE AMOUNT OF FEES ACTUALLY PAID BY
      YOU TO CLASSGENIUS DURING THE ONE (1) YEAR PERIOD PRECEDING THE DATE OF
      THE EVENT GIVING RISE TO CLASSGENIUS’ LIABILITY.
    </p>
    <h1>
      15.<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp; </span>
      Indemnification
    </h1>
    <p className="MsoNormal">
      15.1&nbsp;You hereby agree to indemnify, defend and hold harmless
      ClassGenius and the ClassGenius Parties&nbsp;
      <i>(each an “Indemnified Party”)</i>, from and against any and all
      liability and costs (including, without limitation, attorneys’ fees and
      costs) incurred by the Indemnified Party(s) in connection with any actual
      or alleged claim arising out of: (a) your or your Students’ use of the
      Service; (b) any breach or alleged breach by you or your Students of these
      Terms; (c) any Feedback or Content provided by you or your Students; (d)
      any breach or alleged breach by you of a third party’s rights, including,
      without limitation, any intellectual property, privacy or publicity
      rights; (e) any damage caused by or alleged to have been caused by you or
      your Students to the Site or Service; or (f) any actual or alleged
      violation or non-compliance by you or your Students with any applicable
      law, rule or regulation.
    </p>
    <p className="MsoNormal">
      15.2&nbsp;Counsel you select for defense or settlement of a claim must be
      consented to by ClassGenius and/or the Indemnified Party(s) prior to
      counsel being engaged to represent you and ClassGenius and/or the
      Indemnified Party(s). You and your counsel will cooperate as fully as
      reasonably required, and provide such information as reasonably requested,
      by the Indemnified Party(s) in the defense or settlement of any claim.
      ClassGenius and/or the Indemnified Party(s) reserves the right, at its own
      expense, to assume the exclusive defense or settlement, and control of any
      matter otherwise subject to indemnification by you. You shall not in any
      event consent to any judgment, settlement, attachment, or lien, or any
      other act adverse to the interest of ClassGenius or any Indemnified
      Party(s) without the prior written consent of ClassGenius and/or the
      Indemnified Party(s).
    </p>
    <h1>
      16.<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp; </span>Changes
      to Service
    </h1>
    <p className="MsoNormal">
      16.1&nbsp;ClassGenius is constantly striving to provide the best possible
      experience for its Service users. You acknowledge and agree that the form
      and nature of the Service which ClassGenius currently provides may change
      from time-to-time without prior notice to you. Changes to the form and
      nature of the Service will be effective with respect to all versions of
      the Service. Examples of changes to the form and nature of the Service
      include, without limitation, changes to fees and payment policies,
      security patches, additional functionality, reduced functionality, and
      other enhancements.
    </p>
    <h1>
      17.<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp; </span>
      Termination of Service
    </h1>
    <p className="MsoNormal">
      17.1&nbsp;You may stop using the Service at any time by closing your
      Account, or ceasing to use the Service. In such event, you will not be
      entitled to any refund of any fees that you have paid prior to you ceasing
      to use the Service.
    </p>
    <p className="MsoNormal">
      17.2&nbsp;ClassGenius reserves the right in its sole discretion to cease
      or suspend providing all or any part of the Service immediately without
      any notice to you, if: (a) you breach, or threaten or intend to breach,
      these Terms; (b) ClassGenius is required to do so under any applicable
      law, rule or regulation; (c) the Service relies on data, services or
      another business relationship between ClassGenius and a third party
      service provider, and such relationship terminates or changes in such a
      way that affects ClassGenius’ ability to continue providing the Service;
      (d) continuing to provide the Service could create a substantial economic
      burden on ClassGenius as determined by ClassGenius in its sole discretion;
      or (e) continuing to provide the Service could create a security risk or
      material technical burden as determined by ClassGenius in its sole
      discretion.
    </p>
    <p className="MsoNormal">
      17.3&nbsp;If your use of the Service is terminated or suspended pursuant
      to Sections 16.1 or 16.2 above, except to the extent prohibited by any
      applicable law, rule or regulation, you will have access to, and the
      ability to export, your Content for a period of thirty (30) calendar days
      following such termination or suspension. Fees will continue to be
      assessed based on your actual use of the Service during such period.
      Without limiting the foregoing, the rights set forth in this Section 16.3
      are subject to your payment of any outstanding fees due upon and after
      termination of your use of the Service.
    </p>
    <p className="MsoNormal">
      17.4&nbsp;Any of your obligations under these Terms which by their nature
      are intended to survive the termination of your use of the Service, shall
      continue to apply to you after you cease to use the Service.
    </p>
    <p className="MsoNormal">
      17.5&nbsp;ClassGenius may notify the relevant law enforcement authorities
      or other third parties, of any illegal or other prohibited conduct by you,
      including, without limitation, your violation of these Terms or
      unauthorized use of the Site or Service.
    </p>
    <h1>
      18.<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp; </span>
      Governing Law &amp; Venue
    </h1>
    <p className="MsoNormal">
      18.1&nbsp;These Terms will be construed and enforced in all respects in
      accordance with the laws of the state of Texas, without reference to its
      choice of law rules. Except as set forth below in Section 17.2, the
      federal and state courts seated in Travis County, Texas shall have sole
      and exclusive jurisdiction for all purposes in connection with any action
      or proceeding that arises from, or relates to, these Terms and you hereby
      irrevocably waive any objection to such exclusive jurisdiction; provided
      however, that ClassGenius may seek to enforce any judgment in its favor in
      any court of competent jurisdiction.
    </p>
    <p className="MsoNormal">
      18.2&nbsp;Notwithstanding the foregoing, ClassGenius may seek injunctive
      or other equitable relief in any court of competent jurisdiction to
      protect its proprietary and other rights. You agree that your breach of
      these Terms may result in immediate and irreparable damage to ClassGenius
      for which there is no adequate remedy at law.
    </p>
    <p className="MsoNormal">
      18.3&nbsp;The United Nations Convention on Contracts for the International
      Sale of Goods in its entirety is expressly excluded from these Terms,
      including, without limitation, application to the Site or Service.
      Furthermore, these Terms&nbsp;
      <i>(including without limitation, the Site and Service)</i>&nbsp;will not
      be governed or interpreted in any way by referring to any law based on the
      Uniform Computer Information Transactions Act (UCITA) or any other act
      derived from or related to&nbsp;UCITA.
    </p>
    <p className="MsoNormal">
      18.4&nbsp;Any cause of action arising under these Terms must be commenced
      by you within one (1) year after the claim or cause of action arises.
    </p>
    <h1>
      19.<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp; </span>Third
      Party Web Sites
    </h1>
    <p className="MsoNormal">
      19.1&nbsp;The Site and Service may provide links to other web sites that
      are not owned or operated by ClassGenius&nbsp;
      <i>(“Third Party Web Sites”)</i>. ClassGenius provides these links to you
      as a convenience only, and ClassGenius does not verify, make any
      representations concerning, or take responsibility for, such Third Party
      Web Sites, or the products or services offered through such third party
      web sites, including, without limitation, the truthfulness, accuracy,
      quality, or completeness of the content of, or activities conducted on,
      such Third Party Web Sites. You should use your own independent judgment
      before accessing and using such Third Party Web Sites, or products or
      services offered through such third party web sites.
    </p>
    <p className="MsoNormal">
      19.2&nbsp;These Terms and the Privacy Policy do not apply to such
      Third-Party Web Sites, and you should review such Third Party Web Sites’
      privacy policies, terms and conditions and business practices as they may
      be different to those of ClassGenius and it is your sole responsibility to
      comply with such terms. Your dealings and communications with any third
      party in connection with the Third Party Web Sites are solely between you
      and such third party.
    </p>
    <p className="MsoNormal">
      19.3&nbsp;Any reference on the Site, or through the Service, to any
      product, process, publication or service of any third party, by trade
      name, domain name, trademark, trade identity, service mark, logo,
      manufacturer or otherwise, does not constitute or imply ClassGenius’
      endorsement or recommendation thereof, and your use of any Third Party Web
      Sites and third party product, process, publication, or service is
      entirely at your own risk.
    </p>
    <h1>
      20.<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp; </span>
      Miscellaneous Legal Terms
    </h1>
    <p className="MsoNormal">
      20.1&nbsp;These Terms and the Privacy Policy, together constitute the
      entire agreement between you and ClassGenius with respect to the Service
      (excluding any services which ClassGenius may provide to you under a
      separate written agreement), and completely supersedes, cancels and
      replaces any and all other written or oral agreements or understandings
      previously existing between you and ClassGenius with respect to the
      Service.
    </p>
    <p className="MsoNormal">
      20.2&nbsp;The failure of ClassGenius to exercise or enforce any right or
      provision of these Terms shall not constitute a waiver of such right or
      provision.
    </p>
    <p className="MsoNormal">
      20.3&nbsp;If any part of these Terms is held invalid, illegal or
      unenforceable, that provision shall be enforced to the maximum extent
      permissible so as to maintain the intent of these Terms, and the other
      parts will remain in full force and effect.
    </p>
    <p className="MsoNormal">
      20.4&nbsp;Any notice or other communications by ClassGenius relating to
      the Service may be made by letter, e-mail or posting on the Site, and you
      hereby consent to receive notices and other communications in electronic
      form to the extent permitted by applicable law.
    </p>
    <p className="MsoNormal">
      20.5&nbsp;These Terms shall not be interpreted or construed to confer any
      rights or remedies on any third parties, except that each Indemnified
      Party shall be a third party beneficiary hereunder and accordingly, shall
      be entitled to directly enforce and rely upon any provision of these Terms
      that confers a right or remedy in favor of it.
    </p>
    <p className="MsoNormal">
      20.6&nbsp;ClassGenius may assign or transfer its rights, or delegate any
      performance, under these Terms to a third party in its sole discretion.
      You may not assign or otherwise transfer your rights, or delegate your
      performance, under these Terms to any third party without in each and
      every case, ClassGenius’ express prior written consent.
    </p>
    <p className="MsoNormal">
      20.7&nbsp;ClassGenius will not be liable for failing or delaying
      performance of its obligations resulting from any condition beyond its
      reasonable control, including but not limited to, governmental action,
      acts of the common enemy, earthquake, fire, flood or other acts of God,
      the elements, epidemics, labor conditions, power failures, and Internet
      disturbances.
    </p>
    <p className="MsoNormal">
      20.8&nbsp;ClassGenius may take any legal action against you to enforce
      these Terms or to prevent the breach of these Terms, including, without
      limitation, seeking equitable remedies or using technical means at its
      disposal. In addition to any other legal, equitable or technical rights
      and remedies that it may have, ClassGenius may without limitation,
      immediately terminate or suspend your use of the Service and access to
      your Content, if ClassGenius believes in its sole discretion that you are
      violating these Terms, or that you intend to do so.
    </p>
    <p className="MsoNormal">
      20.9&nbsp;ClassGenius may add to, change or remove any part, term or
      condition of these Terms or Privacy Policy at any time without prior
      notice to you. It is your responsibility to check these Terms and Privacy
      Policy periodically for changes. By continuing to use the Service, you are
      indicating your acceptance of such changes. However, we will provide
      written notice to you of any significant changes to these Terms or Privacy
      Policy&nbsp;
      <i>
        (including notices posted on the Site or sent to your registered e-mail
        address)
      </i>
      .
    </p>
    <p className="MsoNormal">
      20.10&nbsp;You may not access the Service if you are a direct competitor
      of ClassGenius’, except with our prior written consent. In addition, you
      may not access the Service for purposes of monitoring its availability,
      performance or functionality, or for any other benchmarking or competitive
      purposes.
    </p>
    <h1>
      21.<span style={{ font: '7.0pt "Times New Roman"' }}>&nbsp; </span>Contact
      information
    </h1>
    <p className="MsoNormal">
      If you have any questions about these Terms &amp; Conditions or the
      Services, please contact us at{" "}
      <a href="mailto:help@classgenius.ai">help@classgenius.ai</a>.
    </p>
  </div>
</>

    </div>
  );
}

export default Terms;